import { Button, Input, onEnter, useTheme } from '@ytl/common-web';
import { useCallback, useEffect, useState } from 'react';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';

export const DeviceCodeStage = () => {
  const { translation } = useLanguage();
  const { isLoading } = useOpenAm();
  const [deviceCode, setDeviceCode] = useState('');

  const [error, setError] = useState('');

  const { isWebView } = useTheme();
  // @ts-ignore
  const codeLength = window.isKc ? 9 : 8;

  const sendDeviceCode = useCallback(async () => {
    try {
      // Create a hidden form element
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = window.location.pathname;
      form.style.display = 'none';

      // Add the device code input field
      const input = document.createElement('input');
      input.type = 'text';
      // @ts-ignore
      input.name = window.isKc ? 'device_user_code' : 'user_code';
      input.value = deviceCode;
      form.appendChild(input);

      // Append form to body, submit it, and remove it
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (err) {
      setError(translation.loginRegister.login.device.senderror);
    }
  }, [deviceCode, setError, translation]);

  useEffect(() => {
    // @ts-ignore
    const deviceCodeError = window['__deviceCodeError'];
    // @ts-ignore
    const yuiContext = window['yuiContext'];

    if (typeof deviceCodeError === 'string' && deviceCodeError.length > 0 && !deviceCodeError.startsWith('<#if')) {
      setError(translation.loginRegister.login.device.codenotfound);
    } else if (
      typeof yuiContext === 'object' &&
      yuiContext.deviceLoginSuccess === 'false' &&
      yuiContext.deviceLoginHeader !== ''
    ) {
      setError(translation.loginRegister.login.device.codenotfound);
    }
  }, [setError, translation, isWebView]);

  useEffect(() => {
    const userCode = new URLSearchParams(window.location.search).has('user_code');
    if (userCode) {
    }
  }, []);

  return (
    <>
      <h3>{translation.loginRegister.login.device.title}</h3>
      <div className={'login-page__device-code-content'}>{translation.loginRegister.login.device.content}</div>

      <div className={'login-page__device-code-input-container'}>
        <Input
          label={<div>{translation.loginRegister.login.device.fieldlabel}</div>}
          aria-label={translation.loginRegister.login.device.fieldlabel}
          name={'devicecode'}
          type={'text'}
          value={deviceCode}
          onChange={e => {
            setDeviceCode(e.target.value);
            setError('');
          }}
          disabled={isLoading}
          maxLength={codeLength}
          onKeyUp={onEnter(sendDeviceCode)}
        />
      </div>

      {error && <div className="login-page__container__error">{error}</div>}

      <Button
        variant={'contained'}
        onClick={sendDeviceCode}
        disabled={isLoading || deviceCode.length < codeLength}
      >
        {translation.loginRegister.login.device.button}
      </Button>
    </>
  );
};
